module.exports = __webpack_public_path__ + "img/az_quanqiugou_logo.28ede2e1.png";